import { gql } from '@apollo/client';

export const GET_ALL_QUOTE_SETS = gql`
  query GetAllQuoteSets($userId: String!) {
    getAllQuoteSets(userId: $userId) {
      id
      created_at
      plan_type
      user_id
      agent {
        id
        first_name
        last_name
      }
      quotes {
        id
        plan_id
        plan_name
        plan_sub_type
        carrier_name
        annual_premium
        monthly_premium
        outline_link
      }
    }
  }
`;
